import { useEffect, useState, useMemo } from "react";
import { PlusCircleOutlined, MoreOutlined } from "@ant-design/icons";
import { Spin, Modal, Button, Dropdown } from "antd";
import TableComponent from "../../components/TableComponent";
import { createColumn } from "../../utils/tableUtils";
import { useNavigate, useParams } from "react-router-dom";
import { tableDateFormatter } from "../../utils/formatDate";
import MainButtonComponent from "../../components/MainButtonComponent";
import {
	HeaderComponent,
	Container,
	ContainerHeader,
	ActionButtonComponent,
} from "./styles";
import { useDocumentContext } from "../../context/DocumentContext/DocumentContext";

const DocumentCategoryList = () => {
	const { id } = useParams<{ id: string }>();
	const [tableData, setTableData] = useState<any[]>([]);
	const [isModalVisible, setIsModalVisible] = useState(false);
	const [currentItem, setCurrentItem] = useState<any>(null);
	const { documentList, removeDocument, docCategoryDetail, getDocumentCategoryDetail, getDocumentList, operationStatus } = useDocumentContext();

	const navigate = useNavigate();

	useEffect(() => {
		if (id) {
			getDocumentList(id);
			getDocumentCategoryDetail(id);
		}
	}, [id]);

	useEffect(() => {
		setTableData(documentList);
	}, [documentList]);

	const columns = useMemo(() => [
		createColumn({
			title: "Doküman Adı",
			dataIndex: "name",
			width: 60,
			sorterType: "string",
		}),
		createColumn({
			title: "URL",
			dataIndex: "url",
			width: 110,
			sorterType: "string",
			render: (url) => (
				<a href={url} target="_blank" rel="noopener noreferrer">
					{url}
				</a>
			),
		}),
		createColumn({
			title: "Boyut",
			dataIndex: "size",
			width: 30,
			sorterType: "numeric"
		}),
		createColumn({
			title: "Dosya Tipi",
			dataIndex: "extension",
			width: 30,
			sorterType: "string"
		}),
		createColumn({
			title: "Tarih",
			dataIndex: "creationDate",
			width: 30,
			sorterType: "date",
			render: (text) => tableDateFormatter(text, "DD.MM.YYYY"),
		}),
		createColumn({
			title: "",
			dataIndex: "action",
			width: 20,
			render: (text, record: any) => {
				const menuItems = [
					{
						key: "edit",
						label: "Güncelle",
						onClick: () => navigate(`/edit-document/${record.id}`),
					},
					{
						key: "delete",
						label: "Sil",
						onClick: () => {
							setCurrentItem(record);
							setIsModalVisible(true);
						},
					},
				];

				return (
					<Dropdown menu={{ items: menuItems }} trigger={["click"]}>
						<MoreOutlined />
					</Dropdown>
				);
			},
		}),
	], [tableData]);


	return (
		<div>
			<HeaderComponent>{docCategoryDetail?.name} Dokümanları</HeaderComponent>
			<Container>
				<Spin spinning={operationStatus.type === "loading" && operationStatus.operation === "fetch"}>
					<ContainerHeader>
						<ActionButtonComponent>
							<MainButtonComponent
								style={{ marginRight: "15px" }}
								icon={<PlusCircleOutlined />}
								onClick={() => navigate(`/add-document/${id}`)}
							>
								Yeni Ekle
							</MainButtonComponent>
						</ActionButtonComponent>
					</ContainerHeader>
				</Spin>
				{!(operationStatus.type === "loading" && operationStatus.operation === "fetch") && (
					<TableComponent
						columns={columns}
						dataSource={tableData}
					/>
				)}
			</Container>
			<Modal
				title="Dokümanı Sil"
				open={isModalVisible}
				onCancel={() => setIsModalVisible(false)}
				footer={[
					<Button key="back" type="text" onClick={() => setIsModalVisible(false)}>
						İptal
					</Button>,
					<Button
						loading={operationStatus.type === "loading" && operationStatus.operation === "delete"}
						key="submit"
						type="primary"
						danger
						onClick={async () => {
							await removeDocument(id ?? "", currentItem?.id);
							setIsModalVisible(false);
						}}
					>
						Evet
					</Button>,
				]}
			>
				<p><strong>{`"${currentItem?.name}"`}</strong> belgesini silmek istediğinizden emin misiniz?</p>
			</Modal>
		</div>
	);
};

export default DocumentCategoryList;
